export default "__VITE_ASSET__DiWg5Mmu__"